// Types
import { RootState } from 'types/RootState.types';

export const getRouterLocationPathname = (state: RootState) => state.router?.location?.pathname || '';
export const getRouterLocationSearchSelector = (state: RootState) => state.router?.location?.search || '';
